import React from "react";
import { VsiH4 } from "../../../styled/App.styled";
import { useTitleFromComponent } from "../../../utils/hooks";
import { entHostItems } from "../../../utils/routes";
import NavCard from "../../../components/NavCard";

export default function Hosts({ title }) {
  useTitleFromComponent(title);
	
	return (
		<div>
			<VsiH4>Hosts</VsiH4>
			{entHostItems.map((item, index) => {
				return (
					<NavCard
						{...item}
						key={`nav-card-${item.title
							.toLowerCase()
							.split(" ")
							.join("-")}-${index}`}
					/>
				);
			})}
		</div>
	);
}
